/**
 * @module actions/bookingTime
 */
import axios from 'axios'
import {
  API_URL,
  SET_ORDER_BOOKING_TIMES
} from '../constants'

/**
 * @description Getting booking times
 * @return {Promise} Axios promise
 */
export function getBookingTime (orderId) {
  let url = API_URL + '/BookingTime/Get/' + orderId
  return dispatch => {
    return axios.get(url, { headers: { 'Cache-Control': 'no-cache, no-store' } })    // Prevents simultanous requests from stalling on Chrome
  }
}

/**
 * @description Update booking times
 * @return {Promise} Axios promise
 */
export function saveBookingTime (data) {
  let url = API_URL + '/BookingTime/Post/'
  return dispatch => {
    return axios.post(url, data).then(res => {
      dispatch({
        type: SET_ORDER_BOOKING_TIMES,
        data: res.data
      })
      return res
    })
  }
}

export function GetValidDelivery (data) {
  let url = API_URL + '/BookingTime/GetValidDelivery/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/bookingTime.js